var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "section" }, [
    _c(
      "div",
      { staticClass: "container is-fluid" },
      [
        _c("Header", _vm._b({}, "Header", _vm.$route.meta, false)),
        _c("div", { staticClass: "columns is-centered" }, [
          _c(
            "div",
            { staticClass: "column" },
            [
              _c("ag-grid-vue", {
                staticClass: "ag-theme-alpine",
                staticStyle: { width: "100%", height: "700px" },
                attrs: {
                  "grid-options": _vm.gridOptions,
                  pagination: true,
                  "pagination-auto-page-size": true,
                  "side-bar": _vm.sideBar,
                  "animate-rows": true,
                  "multi-sort-key": "ctrl",
                  "get-child-count": _vm.getChildCount,
                  modules: _vm.modules,
                },
                on: { "grid-ready": _vm.gridReady },
              }),
              _c("div", {
                staticClass: "ag-theme-balham-dark prod-chart",
                attrs: { id: "myChart" },
              }),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }